import React, { useState } from "react";
import "./App.css";
import TopBar from './components/TopBar';
import ChartScreen from './components/ChartScreen';
import BuysignalScreen from './components/BuysignalScreen';

function App() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [view, setView] = useState("");

  const openView = (v) => { setView(v); setDrawerOpen(false); };

  return (
    <div>
      <TopBar onToggle={() => setDrawerOpen(o => !o)} />

      <div className={`drawer ${drawerOpen ? 'open' : ''}`}>
        <div className="nav">
          <button onClick={() => openView('chart')}>Chart</button>
          <button onClick={() => openView('buysignal')}>BuySignal</button>
        </div>
      </div>

      {drawerOpen && <div className="overlay" onClick={() => setDrawerOpen(false)}></div>}

      <div style={{ marginTop: 48 }}>
        {view === '' && <div className="blank">Please open the menu (top-left) and choose a view.</div>}
        {view === 'chart' && <ChartScreen />}
        {view === 'buysignal' && <BuysignalScreen />}
      </div>
    </div>
  );
}

export default App;
